import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Box, Grid, IconButton } from "@mui/material";
import CardImageUploader from "components/CardImageUploader";
import Field from "components/Field";
import { required } from "components/Field/validate";
import TitleHeader from "components/TitleHeader";
import WysiwygEditor from "components/WysiwygEditor";
import { connect } from "formik";

import { useSelector } from "react-redux";

const NutritionDetails = ({
  formik,
  editorValue,
  setEditorValue,
  savedEditorValue,
}) => {
  const { values, setFieldValue } = formik;
  const { type } = useSelector((state) => state.user.userDetails);
  const isReadOnly = type?.toUpperCase() !== 'ADMIN' && values?.status === 'Modèle';
  return (
    <>
      <Grid container spacing={5}>
        <Grid item sm={6} xs={12}>
          <TitleHeader el="h3" mb={3} title="Details" fw={600} fs={16} />
          <Box pr={5} sx={{ borderRight: "1px solid #E0E4EA" }}>
            <Field
              variant="outlined"
              type="text"
              label="Titre du programme"
              placeholder="Titre du programme"
              name="name"
              disabled={isReadOnly}
              validate={required}
              mb={4}
            />
            <Grid container spacing={2}>
              <Grid item sm={9} xs={12} sx={{ display: type?.toUpperCase() === 'ADMIN' || values?.status === 'Modèle' ? 'none' : 'block' }}>
                <Field
                  variant="outlined"
                  type="date"
                  label="Date de début"
                  placeholder="Date de début"
                  name="start_date"
                  validate={type?.toUpperCase() === 'ADMIN' || values?.status === 'Modèle' ? undefined : required}
                  mb={4}
                />
              </Grid>
              <Grid item sm={type?.toUpperCase() === 'ADMIN' || values?.status === 'Modèle' ? 12 : 3} xs={12}>
                <Field
                  type="number"
                  label="Semaines"
                  placeholder="0"
                  name="program_weeks"
                  size="small"
                  disabled={isReadOnly}
                  sx={{ ".MuiInputBase-input": { textAlign: "center" } }}
                  validate={required}
                  min={1}
                  InputProps={{
                    startAdornment: (
                      <IconButton
                        edge="start"
                        onClick={() =>
                          setFieldValue(
                            "program_weeks",
                            values.program_weeks - 1
                          )
                        }
                        disabled={isReadOnly}
                      >
                        <RemoveIcon />
                      </IconButton>
                    ),
                    endAdornment: (
                      <IconButton
                        edge="end"
                        onClick={() =>
                          setFieldValue(
                            "program_weeks",
                            values.program_weeks + 1
                          )
                        }
                        disabled={isReadOnly}
                      >
                        <AddIcon />
                      </IconButton>
                    ),
                  }}
                />
              </Grid>
            </Grid>
            <Box sx={{ pointerEvents: isReadOnly ? 'none' : 'auto', opacity: isReadOnly ? 0.6 : 1 }}>
              <WysiwygEditor
                editorValue={editorValue}
                setEditorValue={setEditorValue}
                savedEditorValue={savedEditorValue}
              />
            </Box>
          </Box>
        </Grid>
        <Grid item sm={6} xs={12}>
          <TitleHeader el="h3" mb={3} title="Media" fw={600} fs={16} />
          <Box mb={2} sx={{ fontSize: "12px", fontWeight: "600" }}>
            Affiche du programme
          </Box>
          <CardImageUploader
            name="thumbnail"
            libraryApi="/api/coach/nutrition/image/library"
            label="Ajouter une affiche"
            view="portrait"
            apiKey="/api/upload/coach/thumbs/program/new_thumb"
            thumbnail={values ? values.thumbnail : null}
            disableAction={!isReadOnly}
            disabled={isReadOnly}
            validationMsg="JPEG ou PNG, max 5Mo. Format portrait recommandé (ex : 800×1000px, ratio 4:5)."
          />
        </Grid>
      </Grid>
    </>
  );
};

export default connect(NutritionDetails);
